// extracted by mini-css-extract-plugin
export var card = "_qj-0";
export var content = "_qj-2";
export var details = "_qj-3";
export var icon = "_qj-1";
export var iconBlue = "_qj-5";
export var iconBrand = "_qj-4";
export var iconGrayBlue = "_qj-6";
export var iconGreen = "_qj-7";
export var iconIndigo = "_qj-8";
export var iconOrange = "_qj-9";
export var iconPurple = "_qj-a";
export var iconRed = "_qj-b";
export var iconWarning = "_qj-c";